import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import install from './utils/install';
import 'animate.css/animate.min.css';
import { Lazyload } from 'vant';
import { Search, Skeleton, SkeletonTitle, SkeletonImage, SkeletonAvatar, SkeletonParagraph } from 'vant';
import { initX } from './utils/inits.js';
import { ensureConfig } from './utils/dataCache.js';

import 'vant/lib/index.css';
// Bootstrap app after ensuring X.Xchanne has been fetched
(async () => {
	try {
		await initX();
	} catch (e) {
		// Swallow init errors; downstream falls back to default channel
	}

	const app = createApp(App);
	app.use(Lazyload);

	app.use(Search);
	app.use(Skeleton);
	app.use(SkeletonTitle);
	app.use(SkeletonImage);
	app.use(SkeletonAvatar);
	app.use(SkeletonParagraph);
	// app.use(showConfirmDialog);
	app.use(install);
	app.use(router);
	app.mount('#app');

	// 首次加载：在 initX 完成（带渠道就绪）后拉取 config 并注入统计
	try {
		await ensureConfig();
		loaddingCnzz();
	} catch (e) { }
})();

// 以下增加js统计代码（直接使用配置中的 HTML）

import { store } from './utils/store.js';

router.afterEach((to, from) => {
	// console.log('config', config);
	loaddingCnzz();

	// loadding51La(); // 51拉js代码。
});

// 首次加载逻辑已移动到上面的启动流程中（确保在 initX 之后）

const loaddingCnzz = () => {
	setTimeout(() => {
		try {
			if (!store?.config?.statistics_js) return;
			const html = store.config.statistics_js || '';
			// console.log('统计代码', html);
			// 与上次相同则不重复注入
			if (window.__statsInjectedHtml === html) return;
			window.__statsInjectedHtml = html;

			// 清理可能的老 51.la 脚本避免冲突（同 id）
			const oldLA = document.getElementById('LA_COLLECT');
			if (oldLA && oldLA.parentNode) oldLA.parentNode.removeChild(oldLA);

			// 清理上一次注入的节点（如果有）
			if (Array.isArray(window.__statsInjectedNodes)) {
				try {
					window.__statsInjectedNodes.forEach((n) => n && n.parentNode && n.parentNode.removeChild(n));
				} catch (_) { }
			}
			window.__statsInjectedNodes = [];

			// 解析 HTML，非脚本节点直接插入，脚本顺序串行（外链加载完成后再执行内联）
			const tmp = document.createElement('div');
			tmp.innerHTML = html;
			const nodes = Array.from(tmp.childNodes);
			const scripts = [];
			nodes.forEach((node) => {
				if (node.tagName && node.tagName.toLowerCase() === 'script') {
					scripts.push(node);
				} else {
					const appended = document.body.appendChild(node.cloneNode(true));
					window.__statsInjectedNodes.push(appended);
				}
			});

			const runScriptsSequentially = (list, i = 0) => {
				if (i >= list.length) return;
				const s = list[i];
				const script = document.createElement('script');
				for (const { name, value } of Array.from(s.attributes)) {
					script.setAttribute(name, value);
				}
				const next = () => runScriptsSequentially(list, i + 1);
				if (s.src) {
					script.onload = next;
					script.onerror = next;
					document.body.appendChild(script);
					window.__statsInjectedNodes.push(script);
				} else {
					script.text = s.text || s.innerHTML || '';
					document.body.appendChild(script);
					window.__statsInjectedNodes.push(script);
					next();
				}
			};
			runScriptsSequentially(scripts);
		} catch (e) {
			// 忽略统计错误
		}
	}, 50);
};

// const loadding51La = () => {
// 	console.log('加载51拉js代码。');
// 	!(function (p) {
// 		'use strict';
// 		!(function (t) {
// 			var s = window,
// 				e = document,
// 				i = p,
// 				c = ''.concat('https:' === e.location.protocol ? 'https://' : 'http://', 'sdk.51.la/js-sdk-pro.min.js'),
// 				n = e.createElement('script'),
// 				r = e.getElementsByTagName('script')[0];
// 			(n.type = 'text/javascript'), n.setAttribute('charset', 'UTF-8'), (n.async = !0), (n.src = c), (n.id = 'LA_COLLECT'), (i.d = n);
// 			var o = function () {
// 				s.LA.ids.push(i);
// 			};
// 			s.LA ? s.LA.ids && o() : ((s.LA = p), (s.LA.ids = []), o()), r.parentNode.insertBefore(n, r);
// 		})();
// 	})({ id: 'KZVGOtiomBeRCJOA', ck: 'KZVGOtiomBeRCJOA' });
// };
